import { render } from "./InvalidScreenSizeWarning.vue?vue&type=template&id=7ed7f302&ts=true"
import script from "./InvalidScreenSizeWarning.vue?vue&type=script&lang=ts"
export * from "./InvalidScreenSizeWarning.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__